import axios from '@/libs/api.request'
//售后单列表
export const apiQuestionorderList = data => {
    return axios.request({
      url: '/questionorder/list',
      method: 'post',
      data
    })
  }
  //详情
export const apiQuestionorderInfo = data => {
    return axios.request({
      url: `/questionorder/info/${data.id}`,
      method: 'post',
      data
    })
  }
  //处理
export const apiQuestionorderOperate = data => {
    return axios.request({
      url: '/questionorder/operate',
      method: 'post',
      data
    })
  }